import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MyButton } from '../../index';
import ClearIcon from '@mui/icons-material/Clear';
import { tableFiltersStyles } from './TableFilters.styles';
import MultiSelectFilter from './MultiSelectFilter';
import DateRangeFilter from './DateRangeFilter';

const TableFilters = ({ filters = [], onFilterChange, onClearFilters }) => {
  const { t } = useTranslation();

  if (!filters.length) {
    return null;
  }

  const handleFilterChange = (filterId, value) => {
    if (onFilterChange) {
      onFilterChange(filterId, value);
    }
  };

  return (
    <Box sx={tableFiltersStyles.container}>
      {/* Date Range Filters - Separate Row */}
      {filters.filter(filter => filter.filterType === 'daterange').map(filter => (
        <DateRangeFilter
          key={filter.id}
          filter={filter}
          onFilterChange={handleFilterChange}
        />
      ))}
      
      {/* Other Filters - Same Row */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
        {filters.filter(filter => filter.filterType !== 'daterange').map(filter => {
          if (filter.filterType === 'multiselect') {
            return (
              <MultiSelectFilter
                key={filter.id}
                filter={filter}
                onFilterChange={handleFilterChange}
              />
            );
          }

          return (
            <FormControl
              key={filter.id}
              sx={tableFiltersStyles.filterControl}
              size="small"
            >
              <InputLabel>{filter.label}</InputLabel>
              <Select
                value={filter.value || ''}
                label={filter.label}
                onChange={e => handleFilterChange(filter.id, e.target.value)}
              >
                <MenuItem value="">
                  <em>{t('table.filters.all')}</em>
                </MenuItem>
                {filter.options?.map((option, index) => (
                  <MenuItem key={option.value || `option-${index}`} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        })}

        {filters.some(f => {
          if (f.filterType === 'daterange') {
            return f.value && (f.value.startDate || f.value.endDate);
          }
          if (Array.isArray(f.value)) {
            return f.value && f.value.length > 0;
          }
          return f.value;
        }) && (
          <MyButton
            variant="outlined"
            startIcon={<ClearIcon />}
            onClick={onClearFilters}
            sx={tableFiltersStyles.clearButton}
            size="small"
          >
            {t('table.filters.clear')}
          </MyButton>
        )}
      </Box>
    </Box>
  );
};

export default TableFilters;
